export const carouselInicio = [
    
   
     {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_381.png",
        "url": "/PBPA"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_240.png",
        "url": "/consultas/Heh"
    },
     {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_241.png",
        "url": "/consultas/Tpa"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_125.png",
        "url": "/convocatorias/Conv004"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_135.png",
        "url": "/Convocatorias/Conv005"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_445.png",
        "url": "/BPCD"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_335.png",
        "url": "/Programas/DI2026"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_336.png",
        "url": "/Convocatorias/Conv001"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_337.png",
        "url": "/DGSP"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_341.png",
        "url": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/vid/CA_350.mp4"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_342.png",
        "url": ""
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_339.png",
        "url": ""
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_340.png",
        "url": ""
    },





]